import { StateParams, StateProvider, StateService } from "@uirouter/angularjs";
import { vsComponentName as ProcessNotesModalComponentName } from "./component";
import {
  vsComponentName as formViewComponentName,
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../records/forms/formView";
import {
  ProcessApiResponse,
  ProcessInstancesNotesView,
  ProcessState,
} from "../../../model/ProcessApi";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { ServiceResponse } from "../../../../records/server/query";

addRoute.$inject = ["$stateProvider"];
export function addRoute($stateProvider: StateProvider, name: string) {
  $stateProvider.state(name, noteState()).state(`${name}.add`, noteAddState());
}

export function noteAddState() {
  return {
    component: formViewComponentName,
    url: "/add",
    resolve: {
      fields: [
        "process",
        (process: ProcessApiResponse<any>) => {
          const states = process.States.filter((s) =>
            ["InProgress", "Complete"].includes(s.StatusCategory)
          ).map((s) => ({
            value: s.Id,
            name: s.Name,
          }));

          return [
            ...fieldHelpers.columnLayout(
              [
                fieldHelpers.selectField({
                  key: "StateId",
                  required: true,
                  options: states,
                }),
              ],
              4
            ),
            ...fieldHelpers.columnLayout(
              [
                fieldHelpers.simpleStringField({
                  key: "Notes",
                  label: "Note",
                  required: true,
                }),
              ],
              1
            ),
          ];
        },
      ],
      model: [
        "process",
        "state",
        (process: ProcessApiResponse<any>, state: ProcessState) => ({
          StateId: process.States.find((s) => s.Id === state?.Id)?.Id,
        }),
      ],
      title: [() => "Add Note"],
      onSubmit: [
        FormViewServiceName,
        "process",
        "$state",
        (
          formViewService: FormViewService,
          process: ProcessApiResponse<any>,
          $state: StateService
        ) => [
          "formViewController",
          "model",
          (formViewController: FormViewController, model: any) =>
            formViewService
              .submitForm<ServiceResponse<ProcessInstancesNotesView>>({
                formObject: model,
                formViewController,
                method: "POST",
                url: `/api/processes/instances/${process.Id}/notes`,
              })
              .then((r) => $state.go("^", undefined, { reload: true })),
        ],
      ],
      onCancel: ["$state", ($state: StateService) => [() => $state.go("^")]],
      showButtonsAtTop: [() => false],
    },
  };
}

export function noteState() {
  return {
    component: ProcessNotesModalComponentName,
    url: "/notes",
    params: {
      state: undefined,
    },
    resolve: {
      state: [
        "$stateParams",
        ($stateParams: StateParams) => $stateParams.state,
      ],
    },
  };
}
